export const getCourseTheme = (courseName) => {
  const name = courseName?.toLowerCase() || "";

  if (name.includes("data science"))
    return {
      icon: "📊",
      color: "#16a34a",
      bg: "#ecfdf5",
      gradient: "linear-gradient(135deg, #166534 0%, #16a34a 100%)",
    };

  if (name.includes("python"))
    return {
      icon: "🐍",
      color: "#f59e0b",
      bg: "#fffbeb",
      gradient: "linear-gradient(135deg, #92400e 0%, #f59e0b 100%)",
    };

  if (name.includes("machine learning"))
    return {
      icon: "🧠",
      color: "#2563eb",
      bg: "#eff6ff",
      gradient: "linear-gradient(135deg, #1e40af 0%, #2563eb 100%)",
    };

  if (name.includes("c++") || name.includes("c / c"))
    return {
      icon: "⚙️",
      color: "#1e3a8a",
      bg: "#eef2ff",
      gradient: "linear-gradient(135deg, #1e1b4b 0%, #1e3a8a 100%)",
    };

  if (name.includes("cloud"))
    return {
      icon: "☁️",
      color: "#0ea5e9",
      bg: "#f0f9ff",
      gradient: "linear-gradient(135deg, #0369a1 0%, #0ea5e9 100%)",
    };

  if (name.includes("marketing"))
    return {
      icon: "📢",
      color: "#e11d48",
      bg: "#fff1f2",
      gradient: "linear-gradient(135deg, #881337 0%, #e11d48 100%)",
    };

  if (name.includes("cyber"))
    return {
      icon: "🛡️",
      color: "#020617",
      bg: "#f1f5f9",
      gradient: "linear-gradient(135deg, #020617 0%, #0f172a 100%)",
    };

  if (name.includes("devops"))
    return {
      icon: "🔧",
      color: "#14b8a6",
      bg: "#f0fdfa",
      gradient: "linear-gradient(135deg, #0f766e 0%, #14b8a6 100%)",
    };

  if (name.includes("full stack"))
    return {
      icon: "🚀",
      color: "#9333ea",
      bg: "#faf5ff",
      gradient: "linear-gradient(135deg, #581c87 0%, #9333ea 100%)",
    };

  if (name.includes("mern"))
    return {
      icon: "🌐",
      color: "#22c55e",
      bg: "#f0fdf4",
      gradient: "linear-gradient(135deg, #15803d 0%, #22c55e 100%)",
    };

  return {
    icon: "💻",
    color: "#6366f1",
    bg: "#f5f3ff",
    gradient: "linear-gradient(135deg, #312e81 0%, #6366f1 100%)",
  };
};